import { MutationTuple } from '@apollo/client';
import { QueryResponses } from './responses';
import { goTo } from '../links/goTo';
import { useStores } from '../../hooks/useStores';

export const handleEndOfInstantHelpSurvey = (
  rootStore: ReturnType<typeof useStores>,
  feedbackWithJson: MutationTuple<any, any>['0'],
) => {
  const responses = rootStore.treeNav.choices.consumeFinalised();
  if (!responses) {
    console.error('No responses found in instant help survey.');
    return goTo.assistance();
  }
  const survey = new QueryResponses(responses);


  const checks = [
    'phoneLanguage',
    'phoneCompanyRegionsCheck',
    'videocallLanguage',
    'videocallCompanyRegionsCheck',
  ];
  const failedChecks = checks.filter(check => survey.get(check)?.answers.some(a => a.key === 'fail'));
  // if any of the checks failed, send feedback and go to assistance screen
  if (failedChecks.length) {
    const lastResponse = responses[responses.length - 1];
    const feedback = lastResponse?.freeText || lastResponse?.value;
    if (feedback) {
      console.log('Sending feedback', `${lastResponse.questionKey}: ${feedback}`);
      feedbackWithJson({
        variables: {
          feedback: JSON.stringify({
            from: 'Unhappy case in instant help survey',
            'Company name': rootStore?.user?.user?.companyName,
            questionKey: lastResponse.questionKey,
            Comment: feedback
          })
        }
      });
    }
    // go to assistance
    return goTo.assistance();
  }

  const assistanceMode = survey.getFirstAnswer('assistanceMode')?.key;
  if (!assistanceMode) {
    console.error('No assistance mode found in survey responses.');
  }

  if(assistanceMode === 'videocall') {
    return goTo.instantHelp('video', {});
  } else {
    const inRegion = survey.getFirstAnswer('currentlyLocatedInRegion')?.key;
    return goTo.instantHelp('phone', {
      userIsInRegion: encodeURIComponent(inRegion === 'yes')
    });
  }
};
